import styled from 'styled-components'
import { YMaps } from 'react-yandex-maps'

export const StyledYMaps = styled(YMaps)`
  width: 100%;
  height: 100%;
  cursor: pointer;
  ${({ createPoint }) => createPoint && `
    cursor: pointer;
  `}
`

export const StyledMap = styled.div`
  width: 100%;
  height: 100%;
  cursor: pointer;
  [class*="ymaps3x0--main-engine-container"] {
    filter: ${({ theme }) => theme.colors.mapFilter};
  }
`
